var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-preloader-wrapper"},[_c('div',{staticClass:"widget-preloader"},[_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')]),_c('div',[_c('div')])])])
}]

export { render, staticRenderFns }